module.exports = __webpack_public_path__ + "static/img/13.c0264c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/13.png
// module id = 8kvM
// module chunks = 0